<template>
  <router-view class="page-frame-box" />
</template>

<script>
export default {};
</script>
<style lang="less">
.page-frame-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
</style>
